// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {uniqueId} from 'lodash';

// Actions
import {closeOverlay, openOverlay} from '../../actions/overlay-actions';

// Styles
import './overlay-trigger.scss';

class OverlayTrigger extends Component {
    state = {
        overlayId: uniqueId('overlay'),
    };

    triggerNode = null;

    getOverlayProps() {
        const {className, triggerType = 'hover'} = this.props;
        const overlayProps = {
            className: classnames('overlay-trigger', className),
            ref: (triggerNode) => (this.triggerNode = triggerNode),
        };

        if (triggerType === 'hover') {
            overlayProps.onMouseOver = this.openOverlay;
            overlayProps.onMouseOut = this.closeOverlay;
        } else {
            overlayProps.onClick = this.openOverlay;
        }

        return overlayProps;
    }

    closeOverlay = () => {
        const {closeOverlay} = this.props;
        const {overlayId} = this.state;

        closeOverlay(overlayId);
    };

    openOverlay = () => {
        const {displayDirection, openOverlay, overlayRenderer} = this.props;
        const {overlayId} = this.state;

        openOverlay({
            displayDirection,
            id: overlayId,
            overlayRenderer,
            triggerNode: this.triggerNode,
        });
    };

    render() {
        const {children} = this.props;

        return <div {...this.getOverlayProps()}>{children}</div>;
    }
}

OverlayTrigger.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    closeOverlay: PropTypes.func,
    displayDirection: PropTypes.string,
    openOverlay: PropTypes.func,
    overlayRenderer: PropTypes.func.isRequired,
    overlays: PropTypes.object.isRequired,
    triggerType: PropTypes.oneOf(['hover', 'click']),
};

const mapStateToProps = (state) => ({
    overlays: state.overlays,
});

const mapDispatchToProps = {
    closeOverlay,
    openOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverlayTrigger);
